import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from '../../icons';
import MaterialPriceUpdateForm from '../../forms/materialPriceUpdateForm';

const MaterialPriceEdit = () => {
	let { id } = useParams();
	const userContext = useUserContext();

	return (
		<div className="hwi-material-price-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageMaterialPrices}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/materialprice">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Edit Material Price
						</div>
						<div className="tabs">
						</div>
					</section>
						<MaterialPriceUpdateForm id={id}></MaterialPriceUpdateForm>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default MaterialPriceEdit;